// frontend/modules/template/stores/context-builder-store.ts
import { create } from 'zustand';
import { 
    NotificationTestResult,
    ContextTransformationResult,
    ValidationResult 
} from '@/shared/api/model';

interface ContextBuilderState {
    transformationResult: NotificationTestResult | ContextTransformationResult | null;
    validationResult: ValidationResult | null;
    isTransforming: boolean;
    isValidating: boolean;
}

interface ContextBuilderActions {
    setTransformationResult: (result: NotificationTestResult | ContextTransformationResult | null) => void;
    setValidationResult: (result: ValidationResult | null) => void;
    setIsTransforming: (isTransforming: boolean) => void;
    setIsValidating: (isValidating: boolean) => void;
    resetState: () => void;
}

export const useContextBuilderStore = create<ContextBuilderState & ContextBuilderActions>((set) => ({
    // Initial state
    transformationResult: null,
    validationResult: null,
    isTransforming: false,
    isValidating: false,

    // Actions
    setTransformationResult: (result) => set({ transformationResult: result }),
    setValidationResult: (result) => set({ validationResult: result }),
    setIsTransforming: (isTransforming) => set({ isTransforming }),
    setIsValidating: (isValidating) => set({ isValidating }),
    resetState: () => set({
        transformationResult: null,
        validationResult: null,
        isTransforming: false,
        isValidating: false
    })
}));
